 
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMenuItemForCartDocument = gql`
    query GetMenuItemForCart($menuId: Int, $dishId: Int, $locale: String, $branchId: Int!, $typeMenu: MenuTypeType) {
  menu(menuId: $menuId, branchId: $branchId, type: $typeMenu) {
    items(id: $dishId) {
      id
      name(locale: $locale)
      nameOrigin
      portions {
        id
        name(locale: $locale)
        nameOrigin
        price
        volume
      }
      unit {
        id
        name
      }
      supplements(isDeleted: false) {
        id
        groupName(locale: $locale)
        groupNameOrigin
        price
        options {
          id
          name(locale: $locale)
          nameOrigin
          price
          deleted
        }
        deleted
      }
      deleted
    }
  }
}
    `;

/**
 * __useGetMenuItemForCartQuery__
 *
 * To run a query within a React component, call `useGetMenuItemForCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemForCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemForCartQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      dishId: // value for 'dishId'
 *      locale: // value for 'locale'
 *      branchId: // value for 'branchId'
 *      typeMenu: // value for 'typeMenu'
 *   },
 * });
 */
export function useGetMenuItemForCartQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemForCartQuery, GetMenuItemForCartQueryVariables> & ({ variables: GetMenuItemForCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemForCartQuery, GetMenuItemForCartQueryVariables>(GetMenuItemForCartDocument, options);
      }
export function useGetMenuItemForCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemForCartQuery, GetMenuItemForCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemForCartQuery, GetMenuItemForCartQueryVariables>(GetMenuItemForCartDocument, options);
        }
export function useGetMenuItemForCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemForCartQuery, GetMenuItemForCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemForCartQuery, GetMenuItemForCartQueryVariables>(GetMenuItemForCartDocument, options);
        }
export type GetMenuItemForCartQueryHookResult = ReturnType<typeof useGetMenuItemForCartQuery>;
export type GetMenuItemForCartLazyQueryHookResult = ReturnType<typeof useGetMenuItemForCartLazyQuery>;
export type GetMenuItemForCartSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemForCartSuspenseQuery>;
export type GetMenuItemForCartQueryResult = Apollo.QueryResult<GetMenuItemForCartQuery, GetMenuItemForCartQueryVariables>;
export const GetCartCurrencyDocument = gql`
    query GetCartCurrency($menuId: Int, $branchId: Int!, $typeMenu: MenuTypeType) {
  menu(menuId: $menuId, branchId: $branchId, type: $typeMenu) {
    branch {
      currencyCode
    }
  }
}
    `;

/**
 * __useGetCartCurrencyQuery__
 *
 * To run a query within a React component, call `useGetCartCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartCurrencyQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      branchId: // value for 'branchId'
 *      typeMenu: // value for 'typeMenu'
 *   },
 * });
 */
export function useGetCartCurrencyQuery(baseOptions: Apollo.QueryHookOptions<GetCartCurrencyQuery, GetCartCurrencyQueryVariables> & ({ variables: GetCartCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCartCurrencyQuery, GetCartCurrencyQueryVariables>(GetCartCurrencyDocument, options);
      }
export function useGetCartCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCartCurrencyQuery, GetCartCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCartCurrencyQuery, GetCartCurrencyQueryVariables>(GetCartCurrencyDocument, options);
        }
export function useGetCartCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCartCurrencyQuery, GetCartCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCartCurrencyQuery, GetCartCurrencyQueryVariables>(GetCartCurrencyDocument, options);
        }
export type GetCartCurrencyQueryHookResult = ReturnType<typeof useGetCartCurrencyQuery>;
export type GetCartCurrencyLazyQueryHookResult = ReturnType<typeof useGetCartCurrencyLazyQuery>;
export type GetCartCurrencySuspenseQueryHookResult = ReturnType<typeof useGetCartCurrencySuspenseQuery>;
export type GetCartCurrencyQueryResult = Apollo.QueryResult<GetCartCurrencyQuery, GetCartCurrencyQueryVariables>;
export type GetMenuItemForCartQueryVariables = Types.Exact<{
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  dishId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  branchId: Types.Scalars['Int']['input'];
  typeMenu?: Types.InputMaybe<Types.MenuTypeType>;
}>;


export type GetMenuItemForCartQuery = { __typename?: 'menuQuery', menu: { __typename?: 'MenuProxy', items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, deleted: boolean, portions?: Array<{ __typename?: 'MenuItemPortionProxy', id: number, name?: string | null, nameOrigin?: string | null, price: number, volume: number }> | null, unit: { __typename?: 'UnitProxy', id: number, name: string }, supplements?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null, price?: number | null, deleted: boolean, options?: Array<{ __typename?: 'MenuSupplementProxy', id: number, name?: string | null, nameOrigin?: string | null, price?: number | null, deleted: boolean }> | null }> | null }> | null } };

export type GetCartCurrencyQueryVariables = Types.Exact<{
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
  typeMenu?: Types.InputMaybe<Types.MenuTypeType>;
}>;


export type GetCartCurrencyQuery = { __typename?: 'menuQuery', menu: { __typename?: 'MenuProxy', branch: { __typename?: 'BranchProxy', currencyCode: string } } };
